import React from "react";
import styles from "./Tag.module.scss";
import classNames from "classnames";
import IsMobile from "../../components/IsMobile/IsMobile";
import PlainButton from "../../components/Button/PlainButton/PlainButton";
import Text from "../Text/Text";
import CrossIcon from "../../icons/CrossIcon";

interface TagProps {
  text: string;
  className?: string;
  mobileOnly?: boolean;
  onClick?: () => void;
}

const Tag = ({ text, className, mobileOnly, onClick }: TagProps) => {
  const Wrapper = mobileOnly ? IsMobile : React.Fragment;
  return (
    <Wrapper>
      <PlainButton
        className={classNames(styles.tagContainer, styles.pointer, className)}
        onClick={onClick}
        aria-label={`Remove ${text}`}
      >
        <Text variant="default" as="span">
          {text}
        </Text>
        <div className={styles.iconContainer}>
          <CrossIcon className={styles.icon} height={10} width={10} />
        </div>
      </PlainButton>
    </Wrapper>
  );
};

export default Tag;
